export const AppHeaderHeight = 72;
export const AppHeaderHeightSm = 64;
export const AppFooterHeight = 72;
export const AppFooterHeightSm = 64;
export const AppMainContentPadding = 60;
export const InBuildAppHeaderHeight = 70;

export const InBuildAppSidebarHeaderHeight = 86;
export const MailAppContentHeaderHeight = 78;

export const TaskDetailHeaderHeight = 72;
export const TaskDetailAddCommentHeight = 72;

export const ChatSidebarHeaderHeight = 124;
export const ChatSidebarTabContainerHeight = 49;
export const ChatFooterHeight = 70;
export const CurrentAuthMethod = 'jwtAuth';
export const appThemeColor = "#2868B2"

export const getAppSidebarHeight = (width, visibleAppFooter) => {
  switch (width) {
    case 'xs':
      return (
        AppHeaderHeightSm +
        AppMainContentPadding +
        InBuildAppHeaderHeight +
        InBuildAppSidebarHeaderHeight +
        (visibleAppFooter ? AppFooterHeightSm : 0)
      );
    case 'sm':
      return (
        AppHeaderHeightSm +
        AppMainContentPadding +
        InBuildAppHeaderHeight +
        InBuildAppSidebarHeaderHeight +
        (visibleAppFooter ? AppFooterHeightSm : 0)
      );
    default:
      return (
        AppHeaderHeight +
        AppMainContentPadding +
        InBuildAppHeaderHeight +
        InBuildAppSidebarHeaderHeight +
        (visibleAppFooter ? AppHeaderHeight : 0)
      );
  }
};

export const getMailContainerHeight = (width, visibleAppFooter) => {
  switch (width) {
    case 'xs':
      return (
        AppHeaderHeightSm +
        AppMainContentPadding +
        InBuildAppHeaderHeight +
        MailAppContentHeaderHeight +
        (visibleAppFooter ? AppFooterHeightSm : 0)
      );
    case 'sm':
      return (
        AppHeaderHeightSm +
        AppMainContentPadding +
        InBuildAppHeaderHeight +
        MailAppContentHeaderHeight +
        (visibleAppFooter ? AppFooterHeightSm : 0)
      );
    default:
      return (
        AppHeaderHeight +
        AppMainContentPadding +
        InBuildAppHeaderHeight +
        MailAppContentHeaderHeight +
        (visibleAppFooter ? AppFooterHeight : 0)
      );
  }
};

export const getContactContainerHeight = (width, visibleAppFooter) => {
  switch (width) {
    case 'xs':
      return AppHeaderHeightSm + AppMainContentPadding + InBuildAppHeaderHeight + (visibleAppFooter ? AppFooterHeightSm : 0);
    case 'sm':
      return AppHeaderHeightSm + AppMainContentPadding + InBuildAppHeaderHeight + (visibleAppFooter ? AppFooterHeightSm : 0);
    default:
      return AppHeaderHeight + AppMainContentPadding + InBuildAppHeaderHeight + (visibleAppFooter ? AppFooterHeight : 0);
  }
};

export const getTaskListSidebarHeight = (width, visibleAppFooter) => {
  switch (width) {
    case 'xs':
      return AppHeaderHeightSm + AppMainContentPadding + InBuildAppHeaderHeight + (visibleAppFooter ? AppFooterHeightSm : 0);
    case 'sm':
      return AppHeaderHeightSm + AppMainContentPadding + InBuildAppHeaderHeight + (visibleAppFooter ? AppFooterHeightSm : 0);
    default:
      return AppHeaderHeight + AppMainContentPadding + InBuildAppHeaderHeight + (visibleAppFooter ? AppFooterHeight : 0);
  }
};

export const getTaskListContainerHeight = (width, visibleAppFooter) => {
  switch (width) {
    case 'xs':
      return AppHeaderHeightSm + AppMainContentPadding + InBuildAppHeaderHeight + (visibleAppFooter ? AppFooterHeightSm : 0);
    case 'sm':
      return AppHeaderHeightSm + AppMainContentPadding + InBuildAppHeaderHeight + (visibleAppFooter ? AppFooterHeightSm : 0);
    default:
      return AppHeaderHeight + AppMainContentPadding + InBuildAppHeaderHeight + (visibleAppFooter ? AppFooterHeight : 0);
  }
};

export const getTaskDetailContainerHeight = (width, visibleAppFooter) => {
  switch (width) {
    case 'xs':
      return (
        AppHeaderHeightSm +
        AppMainContentPadding +
        TaskDetailHeaderHeight +
        TaskDetailAddCommentHeight +
        (visibleAppFooter ? AppFooterHeightSm : 0)
      );
    case 'sm':
      return (
        AppHeaderHeightSm +
        AppMainContentPadding +
        TaskDetailHeaderHeight +
        TaskDetailAddCommentHeight +
        (visibleAppFooter ? AppFooterHeightSm : 0)
      );
    default:
      return (
        AppHeaderHeight +
        AppMainContentPadding +
        TaskDetailHeaderHeight +
        TaskDetailAddCommentHeight +
        (visibleAppFooter ? AppFooterHeight : 0)
      );
  }
};

export const getChatSidebarHeight = (width, visibleAppFooter) => {
  switch (width) {
    case 'xs':
      return (
        AppHeaderHeightSm +
        AppMainContentPadding +
        ChatSidebarHeaderHeight +
        ChatSidebarTabContainerHeight +
        (visibleAppFooter ? AppFooterHeightSm : 0)
      );
    case 'sm':
      return (
        AppHeaderHeightSm +
        AppMainContentPadding +
        ChatSidebarHeaderHeight +
        ChatSidebarTabContainerHeight +
        (visibleAppFooter ? AppFooterHeightSm : 0)
      );
    default:
      return (
        AppHeaderHeight +
        AppMainContentPadding +
        ChatSidebarHeaderHeight +
        ChatSidebarTabContainerHeight +
        (visibleAppFooter ? AppFooterHeight : 0)
      );
  }
};

export const getChatContainerHeight = (width, visibleAppFooter) => {
  switch (width) {
    case 'xs':
      return (
        AppHeaderHeightSm +
        AppMainContentPadding +
        InBuildAppHeaderHeight +
        ChatFooterHeight +
        (visibleAppFooter ? AppFooterHeightSm : 0)
      );
    case 'sm':
      return (
        AppHeaderHeightSm +
        AppMainContentPadding +
        InBuildAppHeaderHeight +
        ChatFooterHeight +
        (visibleAppFooter ? AppFooterHeightSm : 0)
      );
    default:
      return (
        AppHeaderHeight +
        AppMainContentPadding +
        InBuildAppHeaderHeight +
        ChatFooterHeight +
        (visibleAppFooter ? AppFooterHeight : 0)
      );
  }
};

export const getWallHeight = (width, visibleAppFooter) => {
  switch (width) {
    case 'xs':
      return AppHeaderHeightSm + AppMainContentPadding + (visibleAppFooter ? AppFooterHeightSm : 0);
    case 'sm':
      return AppHeaderHeightSm + AppMainContentPadding + (visibleAppFooter ? AppFooterHeightSm : 0);
    default:
      return AppHeaderHeight + AppMainContentPadding + (visibleAppFooter ? AppFooterHeight : 0);
  }
};

export const USEastAndWestCoastLocations = [
  {
    position: {
      lat: 35.35313716269399,
      lng: -130.33118411446985,
    },
  },
  {
    position: {
      lat: 35.95963503075226,
      lng: -60.76234587295448,
    },
  },
];

export const LT_SIDE_BAR = {
  ACTIVITY: 'ACTIVITY',
  SHIPMENT: 'SHIPMENT',
};

export const LT_ACTIVITY = {
  STOP_UPDATE: 'STOP_UPDATE',
  CALL_LOG: 'CALL_LOG',
  GEO_FENCING_DATA: 'GEO_FENCING_DATA',
};

export const LT_CALL_STATUS = {
  CIN: 'Checked In', // Stop checked-in, date and time required
  COUT: 'Checked Out', //Stop checked-outm, date and time required
  NOC: "Couldn't connect",
  LVM: 'Left Voicemail',
  CFO: 'Carrier fell off',
  MECH: 'Driver Mechanical Issue/Breakdown',
  OTP: 'Driver is on track for on time pickup',
  OTD: 'Load is on track for On time delivery',
  MPU: 'Driver will miss pick-up',
  MDEL: 'Driver will miss delivery',
  DET: 'Detention being requested',
  RESET: 'Appointment rescheduling will be needed',
  OTH: 'Other',
};

export const LT_CALL_STATUS_KEY = {
  CIN: 'CIN', // Stop checked-in, date and time required
  COUT: 'COUT', //Stop checked-outm, date and time required
  NOC: 'NOC',
  LVM: 'LVM',
  CFO: 'CFO',
  MECH: 'MECH',
  OTP: 'OTP',
  OTD: 'OTD',
  MPU: 'MPU',
  MDEL: 'MDEL',
  DET: 'DET',
  RESET: 'RESET',
  OTH: 'OTH',
};

export const LT_MARKER_TYPES = {
  ETA: 'eta',
  STOP: 'stop',
  LOCATION: 'location',
};

export const LT_CONSTANTS = {
  ETA_UPDATE_FREQUENCY_IN_SEC: 120,
};

export const LT_POLYLINE_TYPES = {
  FULL_ROUTE: 'FULL_ROUTE',
  ROUTE_TO_NEXT_STOP: 'ROUTE_TO_NEXT_STOP',
  TRUCK_LOCATION_HISTORY: 'TRUCK_LOCATION_HISTORY',
};

export const ADVANCED_FILTER = {
  LIMIT: 25,
};

export const StopStatuses = {
  NOT_STARTED: 'Not Started',
  ON_THE_WAY: 'On the way',
  CHECKED_IN: 'Checked in',
  LOADING: 'Loading',
  PICKUP_DONE: 'Pickup done',
  IN_TRANSIT: 'In transit',
  AT_DELIVERY: 'At delivery',
  UNLOADING: 'Unloading',
  DELIVERED: 'Delivered',
};

export const DispatchSourceStatus = {
  COMPLETE: 'Complete',
  DELIVERED: 'Delivered',
  IN_TRANSIT: 'InTransit',
  DISPATCHED: 'Dispatched',
  OUT_FOR_DELIVERY: 'Out for Delivery',
};

export const DispatchStatus = {
  CANCELLED: 'Canceled',
  DISPATCHED: 'Dispatched',
  IN_TRANSIT: 'In Transit',
  DELIVERED: 'Delivered',
  COMPLETED: 'Completed',
};

export const DispatchTrackingStatus = {
  Enabled: 'Enabled',
  Declined: 'Declined',
  Pending: 'Pending',
  Interrupted: 'Interrupted',
  Paused: 'Paused',
};

export const DispatchListingTab = {
  Active: 'Active',
  Completed: 'Completed',
};

export const AdminRoles = {
  Accounting : "Accounting",
  CarrierRep : "Carrier Rep",
  Dispatcher : "Dispatcher",
  GodView : "God View",
  OnboardingTeam : "Onboarding Team",
  QAteam : "QA team",
  SAndCTeam : "S&C Team",
  LaneManagement : "Lane Management"
}

export const userRoleValuesMapping = {
  'company_driver' : 'Company Driver',
  'owner_operator' : "Owner Operator",
  'fleet_owner' : "Fleet Owner",
  'dispatcher' : "Dispatcher",
  'recruiter' : "Recruiter",
  'others' : "Others"
}